import * as _ from "lodash";
import axios from "axios";

class Invoice {
  list(contractId) {
    return axios.get(`/v2/invoice/list/${contractId}`).then((res) => {
      return res.data.invoices;
    });
  }

  getExtratoConsolidado(contractId) {
    return axios.get(`/v2/getXlsxConsolidado/${contractId}`).then((res) => {
      return res.data;
    });
  }

  getTxt(id) {
    return axios.get(`/v2/invoice/getTxt/${id}`).then((res) => {
      return res.data;
    });
  }

  async getLinkNFe(salesOrderId) {
    const res = await axios.get(`/v2/invoice/linkNFe/${salesOrderId}`);
    return res.data;
  }
}

const instance = new Invoice();
export default instance;



// WEBPACK FOOTER //
// ./src/services/invoice.js